module.exports = __webpack_public_path__ + "static/media/group2.a3342947.svg";